import React from "react";
import { useEffect, useState } from "react";
import bannerImage from "../../elements/hero-banner-login-page.png";
import Header from "../../components/header1/Header1";
import card1 from "../../elements/training-program.png";
import card2 from "../../elements/support.png";
import card3 from "../../elements/management.png";
import card4 from "../../elements/online-learning (2).png";
import card5 from "../../elements/internship.png";
import card6 from "../../elements/question.png";
import Footer from "../../components/footer/Footer";
import "./dashboard.css";
import { useNavigate } from 'react-router-dom';
import { fetchStudentLearningTracks } from "../../services/studentportalapis";

const Dashboard = () => {
  const [courseDetails, setCourseDetails] = useState([]);
  const [dynamicCardData, setDynamicCardData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const studentDetails = JSON.parse(localStorage.getItem("student-details"));
    const studentId = studentDetails["studentId"];
    if(studentDetails["firstLogin"]){
      navigate("/reset");
    }

    fetchStudentLearningTracks(studentId)
      .then((data) => {
        setCourseDetails(data);
      })
      .catch((err) => console.error("Error fetching student tracks:", err));
  }, []);

  const cardData = [
    {
      id: 1,
      info: "About The Program",
      image: card1,
      link: "/KnowAbout",
    },
    {
      id: 2,
      info: "Institute Collaboration",
      image: card2,
      link: "/CollegeCollab",
    },
    {
      id: 3,
      info: "Know Your Program Coordinators",
      image: card3,
      link: "/know-your-program-coordinators",
    },
    {
      id: 4,
      info: "My Learning Track",
      image: card4,
      link: courseDetails?.learningTrack?.trackId
        ? `/track/${courseDetails.learningTrack.trackName}/${courseDetails.learningTrack.trackId}`
        : "/learning-track",
    },
    {
      id: 5,
      info: "My Internship Plan",
      image: card5,
      link: "/My-Internship-Plan",
    },
    {
      id: 6,
      info: "FAQs",
      image: card6,
      link: "/faq",
    },
  ];
  useEffect(() => {
    const focusDiv = document.getElementById("focus-div");
    if (focusDiv) {
      focusDiv.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  return (
    <div className="sm:mx-10 md:mx-20">
      <Header />
      <div className="relative w-full">
        <img
          src={bannerImage}
          alt="Banner"
          className="w-full sm:h-[300px] h-auto object-cover"
        />

        <div className="absolute inset-0 flex items-center justify-start top-0 left-0 text-white font-medium p-4 sm:p-6">
          <div className="flex flex-col w-full sm:w-2/5 p-3">
            <p className="text-xl sm:text-xl md:text-xl leading-snug mb-1 text-left break-words lg:text-3xl xl:text-4xl">
              Empowering the Next Generation of Software Engineers: Agivant's
              AI-Driven Revolution
            </p>
          </div>
        </div>
      </div>
      <section id="focus-div" className="py-10 bg-white mt-6 mb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12 max-w-4xl mx-auto px-10">
          {cardData.map((e) => {
  const isInternshipCard = e.id === 5;

  const CardContent = (
    <div
      className={`flex flex-col overflow-hidden bg-white h-48 rounded-xl custom-shadow relative group transition-transform transform ${
        isInternshipCard ? "" : "hover:scale-105"
      }`}
      style={{
        width: "220px",
        margin: "0 auto",
        marginBottom: "30px",
        cursor: isInternshipCard ? "not-allowed" : "pointer",
        opacity: isInternshipCard ? 0.6 : 1,
      }}
    >
      <div className="p-4 flex-shrink-0">
        <img src={e.image} className="w-16 h-16 object-contain mx-auto" />
      </div>
      <div className="flex-1 flex items-center justify-center bg-gradient-to-b from-blue-700 to-red-700 text-white rounded-b-lg">
        <p className="text-md font-semibold text-center m-auto p-2">
          {e.info}
        </p>
      </div>

      {/* Tooltip for "Coming Soon..." */}
      {isInternshipCard && (
        <div className="absolute top-2 right-2 bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
          Coming Soon...
        </div>
      )}
    </div>
  );

  return isInternshipCard ? (
    <div key={e.id}>{CardContent}</div>
  ) : (
    <a href={e.link} key={e.id}>
      {CardContent}
    </a>
  );
})}

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Dashboard;
